import { CoreDropdown } from "@komodo-design-system/komodo-components-react";
import { DropdownOption } from "@komodo-design-system/komodo-core-web-components";
import { isEmpty } from "lodash-es";
import React from "react";
import { useSelector } from "react-redux";

interface AssetType {
  value: string;
  label: string;
}

interface AssetTypeSelectorProps {
  asstType: AssetType;
  setAssetType: (assetType: AssetType) => void;
  isBulkUpload?: boolean; // Optional prop to indicate if it's bulk upload
}

const AssetTypeSelector: React.FC<AssetTypeSelectorProps> = ({ asstType, setAssetType, isBulkUpload }) => {
  const assetTypes = useSelector(
    (state: any) => state.assetTypeReducer?.assetTypes
  );
  const assetTypeLoading = useSelector(
    (state: any) => state.assetTypeReducer?.loading
  );
  const errorAssetType = useSelector(
    (state: any) => state.assetTypeReducer?.error
  );
  let assetTypesDropdown =
        !assetTypeLoading && !errorAssetType && !isEmpty(assetTypes)
          ? Object.entries(assetTypes?.metadata_collection)?.map(([, value]) => {
            const typedValue = value as { name: string }; // Explicitly cast value to the expected type
            return {
              label: typedValue.name,
              value: typedValue.name
            };
          }).filter(
            (item) => item.label !== undefined
          ) as DropdownOption[]
          : [];
  if(isBulkUpload){
    const modelDefaults = assetTypes?.metadata_collection?.MODEL_DEFAULTS;
    assetTypesDropdown = assetTypesDropdown.filter((item) => {
      const modelKey = Object.keys(assetTypes?.metadata_collection || {}).find(
        (key) => assetTypes?.metadata_collection[key]?.name === item.value
      );
      return modelKey && modelDefaults[modelKey]?.is_bulkupload_enabled;
    });
  }
  
  const handleAssetTypeChange = (value: DropdownOption | null) => {
    setAssetType(
      value
        ? { value: value.value || '', label: value.label || '' }
        : { value: '', label: '' }
    );
  };

  return (
    <div className="asset-type-selector" style={{ textAlign: 'left' }}>
      <CoreDropdown
        label="Asset Type"
        placeholder="Select Asset Type"
        functionality="single-select"
        style={{ width: '45%' }}
        customkey="value"
        options={assetTypesDropdown}
        selected={asstType?.value ? [asstType.value] : []}
        onSelectionChanged={(event) =>
          handleAssetTypeChange(event.detail.option)
        }
        filterable={true}
        menusize={4}
      />
    </div>
  );
};

export default AssetTypeSelector;